import {useState} from 'react'
import * as Yup from 'yup'
import {Formik, Form, Field} from 'formik'
import {KTIcon} from '@/_metronic/helpers'
import {useListView} from '@/components/table/core/ListViewProvider'
import {FormActions} from '@/components/form/Actions'
import {computeStock} from '../../core/_requests'
import {DatePicker} from '@/components/form'

const schema = Yup.object({
  date: Yup.date().required('Date is required')
})

const ComputeStockForm = () => {
  const [error, setError] = useState<string | undefined>()
  const {setItemForUpdate, setAction} = useListView()

  const close = () => {
    setItemForUpdate(undefined)
    setAction(undefined)
  }

  return (
    <>
      {error && (
        <div className="alert alert-warning d-flex align-items-center p-5 mb-10">
          <KTIcon iconName="information" className="fs-5x me-4 text-warning" />

          <div className="d-flex flex-column">
            <h5 className="mb-1">{error}</h5>
            <span>An error happened computing stock!</span>
          </div>
        </div>
      )}

      <Formik
        initialValues={{date: new Date()}}
        validationSchema={schema}
        onSubmit={async (values) => {
          try {
            if (values.date) {
              const data = await computeStock(values.date)
              const blob = new Blob([data], {type: 'text/csv'})
              const a = document.createElement('a')

              a.href = URL.createObjectURL(blob)
              a.download = `stock-at-${values.date.toISOString().slice(0,10)}.csv`
              a.click()

              close()
            }
          } catch (e: any) {
            setError(e?.response?.statusText)
          }
        }}
      >
        {(props) => (
          <Form id="product-status" className='form'>
            <Field
              component={DatePicker}
              label='At'
              name="date"
              id="at"
              required={true}
              options={{ dateFormat: "Y-m-d" }}
            />

            <Field
              position="end"
              padding="pt-5"
              component={FormActions}
              close={close}
            />
          </Form>
        )}
      </Formik>
    </>
  )
}

export default ComputeStockForm
